import "./styles.css";
import "./i18n/index.ts";

void import("./ui/app.ts");
